const getFirstLine = (str: string) => (str != null && str.length > 0 ? str.split("\n")[0] : "");

const getValidRegexExp = (pattern: string): RegExp | null => {
    try {
        let lastSlash = pattern.lastIndexOf("/") + 1;
        let lastChar = pattern.length - 1;
        let p = pattern.substring(pattern.indexOf("/") + 1, pattern.lastIndexOf("/"));
        let a = lastSlash > lastChar ? "" : pattern.substring(lastSlash, pattern.length);
        let r = new RegExp(p, a);
        return r;
    } catch {
        return null;
    }
};

const stringContains = (str: any, search: string): boolean => {
    if (!search || search === "") return true;
    if (!str && search.indexOf('(^$)') < 0) return false;
    let str2 = str.toString().trim();
    if ((search.endsWith('"') && search.startsWith('"')) || (search.endsWith("'") && search.startsWith("'"))) {
        let result = str2.trim().toLowerCase() === search.trim().substring(1, search.length - 1);
        return result;
    }
    if (search[0] === "/") {
        let r = getValidRegexExp(search);
        let result = r === null ? true : str.toString().match(r);
        return result;
    }
    let result = str.toString().trim().toLowerCase().indexOf(search.trim().toLowerCase()) !== -1;
    return result;
};

function truncateString(input: string, maxLength: number): { input: string; truncated: string } {
    if (input.length <= maxLength) {
        return {
            input: input,
            truncated: input
        };
    }

    const shortenedStr = input.slice(0, maxLength - 3) + "...";
    return { input: input, truncated: shortenedStr };
}

function capitalizeFirstLetter(input: string): string {
    return input.charAt(0).toUpperCase() + input.slice(1);
}

export { getFirstLine, getValidRegexExp, stringContains, truncateString, capitalizeFirstLetter };
